// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/users/plugins

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function AddpanelAccountSubscriptionList(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'AddpanelAccountSubscriptionList',
      'aria-hidden': true,
      focusable: false,
      width: 44 * scale,
      height: 44 * scale,
      viewBox: '0 0 44 44',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M22 38.484c-9.104 0-16.484-7.38-16.484-16.484 0-9.104 7.38-16.484 16.484-16.484 5.604 0 10.556 2.797 13.534 7.071l-6.666 6.666h15.11V4.143l-4.513 4.513C35.448 3.408 29.119.022 22 .022 9.862.022.022 9.862.022 22c0 12.138 9.84 21.978 21.978 21.978v-5.494zm-1.374-23.352v-2.747h2.748v2.747h4.121v2.747h-6.869a1.38 1.38 0 00-1.373 1.374c0 .753.62 1.373 1.373 1.373h2.748c2.26 0 4.121 1.861 4.121 4.121 0 2.261-1.861 4.121-4.121 4.121v2.747h-2.748v-2.747h-4.121v-2.747h6.869a1.38 1.38 0 001.373-1.374 1.38 1.38 0 00-1.373-1.373h-2.748c-2.26 0-4.121-1.861-4.121-4.121 0-2.261 1.861-4.121 4.121-4.121z',
      fill: 'currentColor',
    })
  );
}
